export const gtmEventTypes = {
  CLICK_PLAY_WATCH_VIDEO: 'YB_CLICK_PLAY_WATCH_VIDEO',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_PLAY_WATCH_VIDEO]: ({CMSGroupGTM, isPlay, videoName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_PLAY_WATCH_VIDEO,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked ${isPlay
      ? 'PLAY'
      : 'WATCH VIDEO'} "${videoName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/feature-youtube-duck.js